fragment flexibleRichtext on flexibleSections_richText_BlockType {
    richText
}
